import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import { FeatureFlagInterface } from '../../store/callrecorder/featureFlagsSlice';

const PREFIX = 'callrecorder';

export const featureFlagsEntity = new schema.Entity('featureFlags');
export const featureFlagEntity  = new schema.Entity('featureFlag');

const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { featureFlags: { [key: string]: FeatureFlagInterface } }
  >(response.data.feature_flags, [featureFlagsEntity]);

  return {
    featureFlags: normalized.entities?.featureFlags || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { featureFlag: FeatureFlagInterface }
  >(response.data.feature_flag, featureFlagEntity);
  return normalized.entities;
}

export const fetchFeatureFlags = createAsyncThunk(
  `${PREFIX}_featureFlags/fetchFeatureFlags`,
  async (bundleId: number | string) => {
    const response = await callrecorderApi.get(`/onesky/bundles/${bundleId}/feature_flags`);
    return normalizeCollection(response);
  }
);

export const updateFeatureFlag = createAsyncThunk(
  `${PREFIX}_featureFlags/updateFeatureFlag`,
  async (
    { bundleId, id, enabled }: { bundleId: number | string, id: number, enabled: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await callrecorderApi.patch(
        `/onesky/bundles/${bundleId}/feature_flags/${id}`,
        { enabled }
      );
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error)
    }
  }
);
